// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import cookies from 'js-cookie'
import VueResource from 'vue-resource'
import router from './router'
import store from './store/store'
import moment from 'moment'
import $ from 'jquery'
import vis from 'vis'
import Vuelidate from 'vuelidate'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'metismenu/dist/metisMenu.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/js/bootstrap'
import 'sweetalert/dist/sweetalert.css'
import md5 from 'js-md5'
import qs from 'qs'
import when from 'when'
import swal from 'sweetalert'
import JsEncrypt from 'jsencrypt/bin/jsencrypt'
import '../node_modules/bootstrap-select/dist/js/bootstrap-select.min'
import '../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css'
import './assets/css/iconfont/iconfont.css'
import './assets/css/global.less'
import '../node_modules/switchery/switchery.css'
import  '../node_modules/switchery/switchery'
//自定义组件
import selectInput from './components/myComponents/selectInput'
import flowInput from './components/myComponents/flowInput'
import flowInputBps from './components/myComponents/flowInputBps'
import singleInput from './components/myComponents/singleInput'
import ipInput from './components/myComponents/ipInput'
import priority from './components/myComponents/priority'
// import 'jquery-ui'
import 'jquery-ui/external/jquery-1.11.0/jquery';
// import './assets/css/jquery-ui.min';
// import './assets/css/jquery.jsPlumb-1.6.2-min.js';
// import 'jquery-ui/dist/js/jquery-ui.min'
import jsPlumb from 'jsplumb';
import 'babel-polyfill';
/*引入公共样式*/
import config from './../static/js/config';
import '../node_modules/font-awesome/css/font-awesome.css';
import './../static/js/metisMenu.min';
import './../static/js/metisMenu';


// import echarts from 'echarts';
// import echartsGL from 'echarts-gl';
import * as echartsGL from 'echarts-gl';
// 引入echarts核心模块
import * as echarts from 'echarts'; //这里是echarts5的引入方式
import * as  THREE from "three";
// import ThreeGlobe from "three-globe";
import loginObj from './../static/js/loginValidate';
// 引入自定义指令
import './components/myComponents/directive.js';
// import 'highcharts'
// import 'highcharts/modules/sankey'
// import 'highcharts/modules/dependency-wheel'
//右键菜单
import Contextmenu from "vue-contextmenujs";
// import iView from "iview";
// import 'iview/dist/styles/iview.css'
import Progress from 'vue-multiple-progress'
Vue.use(Progress)
import Vide from "vide"
Vue.use(Vide)
import particles from 'particles.js'
Vue.use(particles)
import 'video.js/dist/video-js.css'
require('vue-video-player/node_modules/video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import { videoPlayer } from 'vue-video-player'
Vue.use(videoPlayer)

import VirtualList from 'vue-virtual-scroll-list'
Vue.component('virtual-list', VirtualList)

import cwSelect from './components/myComponents/VirtualSelect'
Vue.component('cwSelect', cwSelect);

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)

//注册自定义组件
Vue.component('selectInput',selectInput);
Vue.component('flowInput',flowInput);
Vue.component('flowBps',flowInputBps);
Vue.component('singleInput',singleInput);
Vue.component('ipInput',ipInput);
Vue.component('priority',priority);

Vue.prototype.$echarts = echarts;
Vue.prototype.$echartsGL = echartsGL
// Vue.prototype.$ThreeGlobe = ThreeGlobe
Vue.prototype.$THREE = THREE
// Vue.prototype.$highCharts = highCharts;
Vue.prototype.$jsPlumb = jsPlumb.jsPlumb;
Vue.prototype.$md5 = md5;
Vue.prototype.$qs = qs;
Vue.prototype.$vis = vis;
Vue.prototype.$jsEncrypt = JsEncrypt;
Vue.prototype.$cookies = cookies;
Vue.prototype.$swal = swal;
Vue.prototype.$when = when;
Vue.prototype.$jq = $;
Vue.prototype.$moment = moment;
axios.defaults.withCredentials = true;
import { Loading } from 'element-ui';

//局部等待效果
// loading框设置局部刷新，且所有请求完成后关闭loading框
// let loading;
// function startLoading (targetdq) {
//   loading = Vue.prototype.$loading({
//     lock: true,
//     text: "Loading...",
//     background: 'rgba(255, 255, 255, 0.5)',
//     target: document.querySelector(targetdq) // 设置加载动画区域
//   })
// }
// //关闭loading
// function endLoading () {
//   loading.close();
// }

Vue.prototype.startLoading=function(targetdq){
    return Vue.prototype.$loading({
    lock: true,
    text: "Loading...",
    background: 'rgba(255, 255, 255, 0.5)',
    target: document.querySelector(targetdq) // 设置加载动画区域
  })
}

//loading对象
let loading;

//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading(target) {
  // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: "Loading...",
      background: 'rgba(255, 255, 255, 0.5)',
      target: target || "body"
    });
  }
  needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
  if (needLoadingRequestCount === 0) {
    //关闭loading
    toHideLoading();
  }
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
var toHideLoading = _.debounce(()=>{
  loading.close();
  loading = null;
}, 300);


//解决跨域
// axios.defaults.headers.post['Content-Type'] = 'text/plain'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
// axios.defaults.headers.put['Content-Type'] = 'application/json; charset=utf-8';
// 添加请求拦截器
axios.interceptors.request.use(config => {
  // if(!cookies.get("advertiser_id")){
  //   router.push("/login")
  // }
  // 在发送请求之前做些什么
  // store.commit('showLoading')
  // 这里的config包含每次请求的内容
  let token = localStorage.getItem('token')
  if (token) {
    config.headers.tismo_token = `${token}`;
  } else {}

  //判断当前请求是否设置了不显示Loading
  if(config.headers.showLoading == true) {
    showLoading(config.headers.loadingTarget);
  }
    return config;
}, error => {
  // 对请求错误做些什么
  //判断当前请求是否设置了不显示Loading
  if(config.headers.showLoading == true){
    hideLoading();
  }
  return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做点什么
  // store.commit('hideLoading');
  // if (response.data.code ===401001) {
  //   router.push("/login");
  //   localStorage.setItem("activeMenu", 1);//重置为首页
  //   return;
  // }

  //判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
  if(response.config.headers.showLoading == true){
    hideLoading();
  }

  return response;
}, error => {
  //判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
  if(error.config.headers.showLoading == true){
    hideLoading();
  }
  // 对响应错误做点什么
  store.commit('hideLoading')
  return Promise.reject(error);
});
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(VueResource);
// import locale from 'element-ui/lib/locale/lang/zh-CN';
import locale from 'element-ui/lib/locale/lang/en';
Vue.use(ElementUI,{locale});
Vue.use(Contextmenu);
Vue.use(Vuelidate);
// Vue.use(iView);
Vue.use(THREE);
Vue.http.options.xhr = {withCredentials: true};
/* eslint-disable no-new */
//登录验证
let app = new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>',
});

// 路由跳转前的钩子
router.beforeEach((to, from, next) => {
  next();
});

// 路由跳转后的钩子
router.afterEach((to,from,next) => {
  ga('set', 'page', to.path)
  ga('send', 'pageview')
  store.commit('hideLoading');
  // next();
});


function formatDate(date, fmt) {
  if(!date){
    return "";
  }
  date = new Date(date);
  if (typeof(fmt) === "undefined") {
    fmt = "yyyy-MM-dd HH:mm:ss";
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
    }
  }
  return fmt
};

//定义一个时间过滤器
Vue.filter("formatDate", function(date, fmt) {
  return formatDate(date, fmt);

});

Vue.prototype.$formatDate = formatDate
import vcolorpicker from 'vcolorpicker'
Vue.use(vcolorpicker)
Vue.directive('defaultSelect', {
  componentUpdated (el, bindings, vnode) {
    // values v-model 绑定值
    // options 下拉选项
    // prop 对应 options 中 的 value 属性
    // defaultProp 默认值判断属性
    // defaultValue 默认值判断值
    const [values, options, prop, defaultProp, defaultValue] = bindings.value
    // 需要隐藏的标签索引
    const indexs = []
    const tempData = values.map(a => options.find(op => op[prop] === a))
    tempData.forEach((a, index) => {
      if (a[defaultProp] === defaultValue) indexs.push(index)
    })
    const dealStyle = function (tags) {
      tags.forEach((el, index) => {
        if (indexs.includes(index) && ![...el.classList].includes('select-tag-close-none')) {
          el.classList.add('none')
        }
      })
    }
    // 设置样式 隐藏close icon
    const tags = el.querySelectorAll('.el-tag__close')
    if (tags.length === 0) {
      // 初始化tags为空处理
      setTimeout(() => {
        const tagTemp = el.querySelectorAll('.el-tag__close')
        dealStyle(tagTemp)
      })
    } else {
      dealStyle(tags)
    }
  }
})

//js实现类似php trim函数
function trim(str, char) {
  if (char) {
    str=str.replace(new RegExp('^\\'+char+'+|\\'+char+'+$', 'g'), '');
  }
  return str.replace(/^\s+|\s+$/g, '');
};


//导出echarts的方法
Vue.prototype.exportEcharts = function (echartId, title, type){
  // let myChart = this.$echarts.getInstanceByDom(document.getElementById(echartId));
  let myChart = this.$echarts.init(document.getElementById(echartId));
  const picInfo = myChart.getDataURL({
    // 导出的格式，可选 png, jpg, svg
    // 注意：png, jpg 只有在 canvas 渲染器的时候可使用，svg 只有在使用 svg 渲染器的时候可用
    type: type,
    // 导出的图片分辨率比例，默认为 1。
    pixelRatio: 1.5,
    // 导出的图片背景色，默认使用 option 里的 backgroundColor
    backgroundColor: "white",
    // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox']
    excludeComponents: 'toolbox'
  });
  const elink = document.createElement('a');
  elink.download = title;//导出图片的名字
  elink.style.display = 'none';
  elink.href = picInfo;
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href); // 释放URL 对象
  document.body.removeChild(elink);//删除创建节点

}

//js实现类似php trim函数
// function trim(str, char) {
//   if (char) {
//     str=str.replace(new RegExp('^\\'+char+'+|\\'+char+'+$', 'g'), '');
//   }
//   return str.replace(/^\s+|\s+$/g, '');
// };


//导出echarts的方法
Vue.prototype.exportEchartsSvg = function (echartId, title, type){
  let myChart = this.$echarts.init(document.getElementById(echartId), null, {renderer:"svg"});
  const picInfo = myChart.getDataURL({
    // 导出的格式，可选 png, jpg, svg
    // 注意：png, jpg 只有在 canvas 渲染器的时候可使用，svg 只有在使用 svg 渲染器的时候可用
    type: type,
    // 导出的图片分辨率比例，默认为 1。
    pixelRatio: 1.5,
    // 导出的图片背景色，默认使用 option 里的 backgroundColor
    backgroundColor: "white",
    // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox']
    excludeComponents: 'toolbox'
  });
  const elink = document.createElement('a');
  elink.download = title;//导出图片的名字
  elink.style.display = 'none';
  elink.href = picInfo;
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href); // 释放URL 对象
  document.body.removeChild(elink);//删除创建节点

}

Vue.prototype.exportEchart=function (echartId, title, type){
  let myChart = this.$echarts.init(document.getElementById(echartId));
  if(myChart){
    // echarts官网文档实例方法getDataURL
    let picInfo = myChart.getDataURL({
      type: 'png',
      pixelRatio: 1.5,  // 放大两倍下载。解决生成图片在移动端模糊问题
      backgroundColor: '#fff',
      excludeComponents: ['toolbox']	// 导出时忽略toolbox组件
    });// 获取到的是一串base64信息
    if(type == 'png'){
      const elink = document.createElement('a');
      // 设置默认文件名，this.chartTitle为绘图时生成的标题
      elink.download = title + ".png";
      elink.style.display = 'none';
      elink.href = picInfo;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else if(type == 'svg'){
      let mycanvas = document.querySelector('#' + echartId+ ' canvas');
      //设置svg标签属性
      let svg0 = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg0.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg0.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      svg0.setAttribute('version', '1.1');
      svg0.setAttribute('height', mycanvas.height/2);
      svg0.setAttribute('width', mycanvas.width/2);
      let img3 = document.createElementNS('http://www.w3.org/2000/svg','image');
      // base64编码写入href
      img3.href.baseVal = picInfo;
      img3.setAttribute('height', mycanvas.height/2);
      svg0.appendChild(img3);
      let h = svg0.outerHTML;
      //给图片对象写入base64编码的svg流
      let data = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(h)));

      JsFileDownload(dataURLtoBlob(data), title + ".svg");

      // const elink = document.createElement('a');
      // // 设置默认文件名，this.chartTitle为绘图时生成的标题
      // elink.download = title + ".svg";
      // elink.style.display = 'none';
      // elink.href = data;
      // document.body.appendChild(elink);
      // elink.click();
      // URL.revokeObjectURL(elink.href); // 释放URL 对象
      // document.body.removeChild(elink);
    }
  }else{
    this.$message({
      message: 'no data.',
      type: 'error'
    });
  }
}

// 将base64转blob
function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
//将blob转换为file
function blobToFile(theBlob, fileName) {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
}

// console.log('base64Data', base64Data.length); // 原长度
// compressImage(base64Data, 150, 'image/png', (newBase64Data) => {
//   console.log('newBase64Data', newBase64Data.length); // 压缩后的长度
//   const blob = dataURLtoBlob(newBase64Data);
//   const file = blobToFile(blob, 'image.png');
//   const formData = new FormData();
//   formData.append("file", file);
//   console.log('formData', formData);
// });

/**
 * 指定大小
 */
function compressImage(base64, w, format = 'image/png', callback) {
  var newImage = new Image();
  var quality = 0.6;    //压缩系数0-1之间
  newImage.src = base64;
  newImage.setAttribute("crossOrigin", 'Anonymous');  //url为外域时需要
  var imgWidth, imgHeight;
  newImage.onload = function () {
    imgWidth = 160;
    imgHeight = 90;
    var canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = w * imgHeight / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = w * imgWidth / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      quality = 0.6;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
    var base64 = canvas.toDataURL(format, quality); //压缩语句
    // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
    while (base64.length / 1024 > 150) {
      quality -= 0.01;
      base64 = canvas.toDataURL(format, quality);
    }
    // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
    // while (base64.length / 1024 < 50) {
    //  quality += 0.001;
    //  base64 = canvas.toDataURL("image/jpeg", quality);
    // }
    callback(base64);//必须通过回调函数返回，否则无法及时拿到该值，return拿不到
  }
}

import exportPdf from "./components/myComponents/ExportPdf";
Vue.use(exportPdf)

Vue.prototype.URLencode=function(sStr){
  // return escape(sStr).replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F');
  return escape(sStr).replace(/\+/g, '%2B');
}

import MathJax, { initMathJax, renderByMathjax } from "mathjax-vue";
import JsFileDownload from "js-file-download";
function onMathJaxReady() {
  const el = document.getElementById("myMathJax");
  renderByMathjax(el);
}

initMathJax({}, onMathJaxReady);

Vue.use(MathJax);

// "echarts": "^4.2.0-rc.2",
// "echarts-liquidfill": "^2.0.4",
// "echarts-gl": "^1.0.2",


// import './components/myComponents/google_access.js';
// window.dataLayer = window.dataLayer || [];
// function gtag() { dataLayer.push(arguments); }
// gtag('js', new Date());
// gtag('config', 'G-87TD8EF1MJ');

//<!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=G-87TD8EF1MJ"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag() { dataLayer.push(arguments); }
//   gtag('js', new Date());
//
//   gtag('config', 'G-87TD8EF1MJ');
// </script>



// WEBPACK FOOTER //
// ./src/main.js